import React, { useEffect, useState } from 'react';

import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntPesticides, PesticideDetails } from "../../../../models/chemicalization/pesticides";
import { Col, DatePicker, Form, message, Row, Space } from "antd";
import { dateFormat } from "../../../../utils";
import dayjs, { Dayjs } from "dayjs";
import { PesticidesItems } from "./PesticidesItems";
import { SelectTerritorialUnits } from "../../../../components/selects";

enum FormField {
  id,
  periodStart,
  periodEnd,
  territorialUnitId,
}

interface IProps {
  show: boolean;
  pesticides: EntPesticides;
  onHide: () => void;
  onSubmit: (pos: EntPesticides) => Promise<boolean>;
}

export const AddPesticidesModal = (props: IProps) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<Dayjs|null>(null);
  const [items, setItems] = useState<PesticideDetails[]|null>(null);
  const [checkStatus, setCheckStatus] = useState<boolean>(false);

  useEffect(() => {
	if (props.show) {
	  if (props.pesticides.id === null) {
		setItems(null);
	  }
	  setFieldsFromEntity();
	}
  }, [props.show]);


  const setFieldsFromEntity = (): void => {
	form.setFields([
	  {
		name: FormField.periodStart,
		value: props.pesticides.periodStart === null ? undefined : dayjs(props.pesticides.periodStart)
	  },
	  {
		name: FormField.periodEnd,
		value: props.pesticides.periodEnd === null ? undefined : dayjs(props.pesticides.periodEnd)
	  },
	  { name: FormField.territorialUnitId, value: props.pesticides.territorialUnits?.id },
	]);
	if (props.pesticides.pesticideDetails !== null) {
	  setItems(props.pesticides.pesticideDetails)
	}
  };

  const setEntityFromFields = (): EntPesticides => {
	let res = _.cloneDeep(props.pesticides);
	res.territorialUnitId = form.getFieldValue(FormField.territorialUnitId);
	res.periodStart = form.getFieldValue(FormField.periodStart)?.format("YYYY-MM-DD");
	res.periodEnd = form.getFieldValue(FormField.periodEnd)?.format("YYYY-MM-DD");
	res.pesticideDetails = items;
	return res;
  }

  const hideModal = () => {
	props.onHide();
	setCheckStatus(false)
	setItems(null)
  };

  const handleSubmit = async () => {
	setLoading(true);
	try {
	  await form.validateFields();
	  const data = setEntityFromFields();
	  const { pesticideDetails } = data;


	  if (!pesticideDetails || pesticideDetails.length === 0) {
		throw new Error("Список не должен быть пустым!");
	  }

	  const invalidRegisters = pesticideDetails.filter(
		(pesticideDetails: PesticideDetails) =>
		  pesticideDetails.neededTonnes === null ||
		  pesticideDetails.suppliedTonnes === null ||
		  pesticideDetails.pesticidesTypeId === null
	  );

	  if (invalidRegisters.length > 0) {
		throw new Error("У всех элементов должны быть заполнены!");
	  }

	  const result = await props.onSubmit(data);
	  if (result) hideModal();
	} catch (error: any) {
	  message.error(error.message || "Произошла ошибка при отправке формы.");
	} finally {
	  setLoading(false);
	}
  };

  return (
	<>
	  <DraggableModal
		title={ props.pesticides.id === null ? t("general.add") : t('general.edit') }
		visible={ props.show }
		onCancel={ props.onHide }
		onSubmit={ handleSubmit }
		submitLoading={ loading }
		width={ 800 }
	  >
		<Form
		  initialValues={ { remember: true } }
		  autoComplete="off"
		  layout="vertical"
		  form={ form }
		>
		  <Row style={ { margin: 0 } } gutter={ 16 }>
			<Col className="gutter-row" span={ 12 }>
			  <Form.Item
				label={ t('titles.territorialUnitRegion') }
				name={ FormField.territorialUnitId }
				rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
			  >
				<SelectTerritorialUnits type={ ['REGION'] }/>
			  </Form.Item>
			</Col>
			<Col className="gutter-row" span={ 12 }>
			  <Space.Compact>
				<Form.Item
				  label={ t('general.start_date_period') }
				  name={ FormField.periodStart }
				  rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				>
				  <DatePicker
					format={ dateFormat }
					placeholder={ t('general.select_date') }
					onChange={ (date) => setStartDate(date) }/>
				</Form.Item>
				<Form.Item
				  label={ t('general.end_date_period') }
				  name={ FormField.periodEnd }
				  rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				>
				  <DatePicker
					format={ dateFormat }
					placeholder={ t('general.select_date') }
					disabledDate={ (current) =>
					  !!startDate && current.isBefore(startDate.add(1, "day"), "day")
					}
				  />
				</Form.Item>
			  </Space.Compact>
			</Col>
			<Col className="gutter-row" span={ 24 }>
			  <PesticidesItems setItems={ setItems } items={ items }/>
			</Col>
		  </Row>
		</Form>
	  </DraggableModal>
	</>
  )
};